import { NAVIGATION } from '~/reducers/nav/types';
import log from '~/utilities/log';
import mediator from '~/utilities/mediator';
import { store } from '~/utilities/store';

let lastHandled = new Date();
let initialized = false;

const handlePage = (context: PageContext) => {
  if (context.timing && context.timing < lastHandled) {
    log.debug('tried to handle a page out of order');

    return;
  }

  store.dispatch({ type: NAVIGATION, context });

  // This block will make sure that the location is set in the store BEFORE
  // any component try to read that
  if (!initialized) {
    mediator.publish('app:ready', { nav: true });
    initialized = true;
  }

  lastHandled = context.timing ?? new Date();
};

mediator.subscribe('page', handlePage);
